import React, { ReactNode, DetailedHTMLProps } from "react"
import { css, cx } from "emotion"

export const option = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-bottom: solid 1px #0001;
  min-width: 75px;
  padding: 10px 20px 10px 20px;
  &:hover {
    background: #5551;
  }
`

type ValueType = string | number | boolean | {}

interface IProps
  extends DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children: ReactNode
  value?: ValueType
  className?: string
}

function PopOverItem(props: IProps) {
  return (
    <div onClick={props.onClick} className={cx(option, props.className)}>
      {props.children}
    </div>
  )
}

export default PopOverItem
